import { Navigate } from 'react-router-dom'
import { isProfissional } from '@/utils/profissionalAuth'
import { ProfissionalLoginPage } from './ProfissionalLoginPage'

export function ProfissionalLoginOrRedirect() {
  if (isProfissional()) return <Navigate to="/profissional/painel" replace />
  return <ProfissionalLoginPage />
}

